import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import { getIconForPlace } from 'utils';
import { Marker } from 'google-react-maps';

class MapCreatorPlaces extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { places: current_places } = this.props.mapCreator;
    if(current_places) {
      return (
        <div>
        {current_places.map(place => {
          const coords = place.geometry.location.toJSON();
          const options = {
            icon : {
              url: getIconForPlace(place),
              scaledSize: this.maps? new this.maps.Size(26.25,40.625) : undefined
            }
          };
          return (
            <Marker
              key={place.place_id}
              onClick={this.map != null ? () => this.map.setCenter(place.geometry.location) : null}
              options={options}
              coords={coords}
              map={this.props.map}
              maps={this.props.maps}
            />
          );
        })}
        </div>
      );
    }
    else {
      return <div />;
    }
  }
}

export default mapCreatorConnect(MapCreatorPlaces);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-places.js